import {
  EditGLDAdditionTask,
  EditGLDStartRegistrationTask,
  GLDAdditionTask,
  GLDClosureTask,
  GLDStartRegistrationTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createGldUiSchemaLibrary } from "./gld-ui-schema-library";

/**
 * Unified UI Schema hook for all GLD forms.
 * Returns a shared ui-schema covering all three GLD form types (start-registration,
 * addition, closure).
 */
export function useGldUiSchema(
  qualityRegime: QualityRegimeOptions | undefined
): BrostarUiSchema<
  | GLDStartRegistrationTask
  | EditGLDStartRegistrationTask
  | GLDAdditionTask
  | EditGLDAdditionTask
  | GLDClosureTask
> {
  const lib = createGldUiSchemaLibrary(qualityRegime);

  return {
    "ui:order": ["metadata", "sourcedocumentData", "timeseriesFile"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber: lib.projectNumber,
      broId: lib.broId,
      qualityRegime: lib.qualityRegime,
      deliveryAccountableParty: lib.deliveryAccountableParty,
    },
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      // Start Registration fields
      objectIdAccountableParty: lib.objectIdAccountableParty,
      gmwBroId: lib.gmwBroId,
      tubeNumber: lib.tubeNumber,
      groundwaterMonitoringNets: lib.groundwaterMonitoringNets,
      // Addition fields
      observationId: lib.observationId,
      processReference: lib.processReference,
      evaluationProcedure: lib.evaluationProcedure,
      measurementInstrumentType: lib.measurementInstrumentType,
      airPressureCompensationType: lib.airPressureCompensationType,
      investigatorKvk: lib.investigatorKvk,
      observationType: lib.observationType,
      statusQualityControl: lib.statusQualityControl,
    },
    timeseriesFile: lib.timeseriesFile,
  };
}
